<template>
  <Loading v-if="loading" />
</template>

<script>
import { verifyEmail } from "@/api/user.api";
import apiClient from "@/axios";
import Loading from "@/components/user/layout/LoadingComponent.vue";

export default {
  name: "SetEmailVerify",
  components: {
    Loading,
  },
  data() {
    return {
      loading: true,
      token: this.$route.params.token,
    };
  },
  async created() {
		this.loading = true;
    if(!this.token) {
      this.$router.push("/login");
    } 
    await this.verifyEmail(this.token);
  },
  methods: {
    async verifyEmail(token) {
      try {
        const response = await verifyEmail(token);
        if (response.data.status) {
          this.$router.push("/login");
        } else {
          this.$router.push("/login");
        }
      } catch (error) {
        this.$router.push("/login");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.page-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: var(--background-color);
}
</style>
